import type { OrderSummary } from '../../../../infrastructure/OMSClient';

// Marker is a name substring, not a dedicated field. Real data uses
// "UK EXCLUSIVE" (with or without brackets), so match case-insensitively.
const UK_EXCLUSIVE_MARKER = 'UK EXCLUSIVE';
const UK_COUNTRY_CODES = ['GB', 'UK', 'UNITED KINGDOM'];

export function hasUkExclusiveItem(order: OrderSummary): boolean {
  return order.lineItems.some((item) =>
    [item.name, item.originalName, item.nameKor, item.originalNameKor].some((n) =>
      (n ?? '').toUpperCase().includes(UK_EXCLUSIVE_MARKER),
    ),
  );
}

export function isShippingToUK(order: OrderSummary): boolean {
  const code = (order.consignee?.countryCode || order.shippingAddress?.country || '').toUpperCase();
  return UK_COUNTRY_CODES.includes(code);
}

// UK-exclusive product shipping outside the UK must not be outbounded (SSD-5270).
export function isUkExclusiveShippingBlocked(order: OrderSummary): boolean {
  return hasUkExclusiveItem(order) && !isShippingToUK(order);
}

export const UK_EXCLUSIVE_BLOCK_MESSAGE =
  'Blocked: order contains a [UK EXCLUSIVE] product but ships outside the UK. This order must be canceled — do not outbound.';
